<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">View Reports</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllReportsTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../../router/layouts/main";
import PageHeader from "../../../components/AppComponents/page-header";
import AllReportsTable from "../../../components/Kleyton/Tables/Report/RPT/AllReportsTable";
export default {
  name: "AllReports",
  page: {
    title: "Report",
    meta: [{ name: "All Reports", content: window.__env.app.description }]
  },
  components: {
    AllReportsTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "AllReports",
      title: "All Reports",
      items: [
        {
          text: "Report",
          href: "/"
        },
        {
          text: "All Reports",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
